import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';

export class ActivityUsersDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== 'activity-users') return Promise.reject(new Error('Unsupported resource'));

    const { page = 1, perPage = 100 } = params.pagination || {};
    const { filter = {} } = params;
    const tierBenefitID = (filter as any)?.tierBenefitID ?? '2';
    const limit = perPage;
    const offset = (page - 1) * perPage;
    const url = `${baseUrl}/activity/adminGetTopUsers?limit=${limit}&offset=${offset}`;

    try {
      const { json } = await httpClient(url, {
        method: 'GET',
        body: JSON.stringify({ tierBenefitID }),
      });

      let rows: any[] = [];
      let total = 0;
      if (Array.isArray(json)) {
        rows = json;
        total = json.length;
      } else if (json?.data && Array.isArray(json.data)) {
        rows = json.data;
        total = json.total ?? rows.length;
      }

      // 确保每条记录都有 id
      const data = rows.map((r: any, i: number) => ({ id: r?.userId ?? `${i}`, ...r }));

      return { data, total };
    } catch (error) {
      console.error('ActivityUsersDataProvider getList error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async create(resource: string, params: any): Promise<any> {
    // 仅拦截 activity/tasks 列表对应的创建
    if (resource !== 'activity-task-category') return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/createTaskCategory`;
    const payload = params?.data ?? {};

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json?.data ?? json };
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (resource !== 'activity-task-category') return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/updateTaskCategory`;
    const payload = params?.data ?? {};
    console.log('ActivityTasksDataProvider update payload:', params);

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json?.data ?? json };
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(resource: string, params: any): Promise<any> {
    if (resource !== 'activity-task-category') return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/deleteTaskCategory`;
    const payload = { taskId: params?.id ?? params?.previousData?.id };

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json ?? { id: payload.taskId } };
  }
}

// 创建实例并导出
export const activityUsersDataProvider = new ActivityUsersDataProvider();
